import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { Bar } from "react-chartjs-2";

import {
  MetricKey,
  computeNormalizedSummarizedDataSet,
  mapSummarizedDataSet,
  summarizeStatistic,
} from "@/lib/statistics-analytic-utils";
import { PeriodStatisticsDto } from "@/shared/api";

import { Currency, colorPool } from "../util";

export function BarAuChart({ data }: { data: PeriodStatisticsDto[] }) {
  const summarized = useMemo(() => summarizeStatistic(data), [data]);
  const dataSet = useMemo(
    () => computeNormalizedSummarizedDataSet(mapSummarizedDataSet(summarized)),
    [summarized]
  );

  const [selectedMetric, setSelectedMetric] = useState<MetricKey>("AU");

  const chosenMetrics = useMemo(() => dataSet.data[selectedMetric], [dataSet, selectedMetric]);

  return (
    <>
      <FormControl sx={{ minWidth: 320, marginBottom: 2 }} size="small">
        <InputLabel id="demo-simple-select-label">Currency</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedMetric}
          label="Currency"
          onChange={(e) => setSelectedMetric(e.target.value as MetricKey)}
        >
          <MenuItem value="AU">AU</MenuItem>
          <MenuItem value="Rake">Rake</MenuItem>
          <MenuItem value="Hands">Hands</MenuItem>
        </Select>
      </FormControl>

      <Box sx={{ flex: 1, height: "100%" }}>
        <Bar
          data={{
            labels: dataSet.periods,
            datasets: chosenMetrics
              .entries()
              .map(([key, value], index) => ({
                label: key,
                data: value,
                borderWidth: 1,
                backgroundColor: colorPool[index % colorPool.length],
              }))
              .toArray(),
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { position: "top" },
              title: {
                display: true,
                text: selectedMetric,
              },
            },
            scales: {
              x: {
                stacked: true,
              },
              y: {
                stacked: true,
                ticks: {
                  callback: function (value) {
                    return value.toLocaleString();
                  },
                },
                title: {
                  display: true,
                  text: selectedMetric,
                },
              },
            },
          }}
        />
      </Box>
    </>
  );
}
